import {
	Component,
	Input,
	Output,
	EventEmitter,
	OnChanges
} from '@angular/core';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';

@Component({
	selector: 'sm-date-range',
	template: require('./sm-date-range.component.html')
})
export class SmDateRangeComponent {
	@Input() label: string = '';
	@Input('start') start: Date;
	@Input('end') end: Date;
	@Input('disabled') disabled: boolean;
	@Output('onChange') onChange: EventEmitter<DateRangeModel> = new EventEmitter();

	startDate: NgbDateStruct;
	endDate: NgbDateStruct;

	ngOnChanges() {
		this.startDate = this._getNgbDateStruct(this.start);
		this.endDate = this._getNgbDateStruct(this.end);
	}

	startChanged(start: NgbDateStruct) {
		this.start = start ? new Date(start.year, start.month - 1, start.day) : null;
		this.startDate = start;
		this._fireOnChange();
	}

	endChanged(end: NgbDateStruct) {
		this.end = end ? new Date(end.year, end.month - 1, end.day, 23, 59, 59) : null;
		this.endDate = end;
		this._fireOnChange();
	}

	private _fireOnChange() {
		if (this.onChange) {
			this.onChange.emit({
				start: this.start,
				end: this.end
			});
		}
	}

	private _getNgbDateStruct(date: Date): NgbDateStruct {
		if (date) {
			return {
				day: date.getDate(),
				month: date.getMonth() + 1,
				year: date.getFullYear()
			};
		}

		return null;
	}
}

export interface DateRangeModel {
	start: Date;
	end: Date;
}


// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./app/shared/components/sm-date-range.component.ts